<div>
  @if (node$ | async; as nodes) {
    <div class="brand-menu">
      @for (node of (node$ | async)?.children; track node) {
        <div class="float-left">
          <span class="nav-item brandmenu-titles">
            <ng-container *ngTemplateOutlet="url; context: { node: node }"> </ng-container>
            @if (node.children?.length > 0) {
              <ng-container *ngTemplateOutlet="categorymenulist; context: { node: node }"> </ng-container>
            }
          </span>
        </div>
      }
    </div>
  }
  <ng-template #categorymenulist let-node="node">
    <div class="menu-contents col-lg-4 p-0">
      <div class="col-lg-12 p-0 position-relative float-left">
        <div class="">
          @for (child of node.children; track child) {
            <div class="">
              <span class="d-flex align-items-start"
                [ngClass]="{ 'account-dropdown-item custom-child-hover': !blockedWords.includes(child.title) }">
                @if (!blockedWords.includes(child.title)) {
                  <ng-container *ngTemplateOutlet="url; context: { node: child }"> </ng-container>
                } @else {
                  <div class="disabled-link">{{ child.title }}</div>
                }
              </span>
              @if (child.children?.length > 0) {
                <i class="fas fa-chevron-right float-right" aria-hidden="true"></i>
              }
              <ng-container *ngTemplateOutlet="categorySubMenulist; context: { node: child }"> </ng-container>
            </div>
          }
        </div>
      </div>

    </div>

  </ng-template>

  <ng-template #categorySubMenulist let-node="node">
    <div class="col-lg-6 p-2 menu-contents-inner">
      @for (child of node.children; track child) {
        <a class="col-lg-12 p-2 float-left color-font font-size text-center">
          <ng-container *ngTemplateOutlet="url; context: { node: child }"> </ng-container>
        </a>
      }
    </div>
  </ng-template>

  <ng-template #url let-node="node">
    <cx-generic-link [url]="node?.children?.length > 0 ? null : node.url" [target]="node.target">
      {{ node.title }}
    </cx-generic-link>
  </ng-template>

</div>